import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { Aliado } from '../_models/aliado';

@Injectable({
  providedIn: 'root'
})
export class AliadoService {

  private rutServicio = AppSettings.rutServiciosALIADOS + '/api/aliados';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as Aliado[] ) );
  }

  listadoConCampos() {
    return this.httClient.get( this.rutServicio + '/all' ).pipe( map( res => res as Aliado[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as Aliado[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as Aliado ) );
  }

  obtenerPorTercero( idTercero: string ) {
    return this.httClient.get( this.rutServicio + '/tercero/' + idTercero ).pipe( map( res => res as Aliado ) );
  }

  crear( aliado: Aliado ) {
    aliado.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, aliado ).pipe( map( res => res as Aliado ) );
  }

  actualizar( aliado: Aliado ) {
    aliado.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, aliado ).pipe( map( res => res as Aliado ) );
  }

  validarHabilitar( idAliado: string ) {
    return this.httClient.get( this.rutServicio + '/aliado/' + idAliado + '/inhabilitar' ).pipe( map( res => res as any ) );
  }

}
